import ServiceAddButton from './ServicesAddButton';
import ServiceAdd from './ServiceForm/AddServiceFormContainer';
import ServiceDetails from './ServiceDetails/ServiceDetails';
import ServiceEdit from './ServiceForm/EditServiceFormContainer';
import ServiceList from './ServicesList/ServicesList';
import ServicesEmpty from './ServicesEmpty/ServicesEmpty';

export { watchActions as watchServicesActions } from './Services.saga';
export { ServicesContextProvider } from './ServicesContext';
export const ServicesComponents = {
  add: ServiceAdd,
  addButton: ServiceAddButton,
  details: ServiceDetails,
  edit: ServiceEdit,
  list: ServiceList,
  empty: ServicesEmpty,
};
export { default as DeleteServiceModal } from './DeleteServiceModal/DeleteServiceModal';
export { default as ResetScheduleIncrementsModal } from './ScheduleIncrements/ResetScheduleIncrementsModal';
export { default as UpdateIncrementsConfirmationModal } from './ScheduleIncrements/UpdateIncrementsConfirmationModal';
